import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Col, Row, Button, Dropdown } from "react-bootstrap";
import { NGDropdownListItem, SXDropdown } from "@common/components/ui-components/SXDropdown";
import { SXModalBase } from "./SXModal";
import { useTranslation } from "react-i18next";
import { useUser } from "../../features/user/userSlice";
import { AlertMessage, ErrorType } from "../../helpers/AlertMessage";
import { report_exception } from "../ui-components/SXAlert/SXAlertMessage";
import { openModal, closeModal, selectModalById } from "../../features/ui/uiSlice";
import "../../../i18n";
import { NGCustomSection } from "./SXCustomSection";
import { languages } from "../../config/languages";
import { ng } from "@common/ngds";
import { useProject, selectProject } from "../../features/projects/projectSlice";
import { useAppSelector } from "../../app/hooks";
import { selectAllSections, useMaterials } from "../../features/materialsSections/materialSectionSlice";
import { v4 as uuid } from "uuid";

interface SectionCreationModalProps {
  isCreationModalOpen: boolean;
  //  size: string;
  SectionGuid: string;
  modelState: "create" | "edit";
  type: string;
  group: string;
  currentSelectedSectionGuid?: string;
  // setSec: (sec: ng.sections.Section) => void;
}

export const SectionCreationModal = (props: SectionCreationModalProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [section, setSection] = useState<ng.sections.Section | null>(null);

  const { getProjectSectionObj, setProjectSectionGuid } = useProject();
  const currentLanguage = languages.find((lang) => lang.code === i18n.language);
  const { getSection, createSection, editSection } = useMaterials();

  let allSections = useAppSelector(selectAllSections);
  useEffect(() => {
    if (props.isCreationModalOpen) {
      const fetchEditSection = async () => {
        if (props.isCreationModalOpen) {
          let sec = await getSection(props.SectionGuid);
          let sectionObj = ng.sections.Section.fromObject(sec.payload);
          setSection(sectionObj.deepClone());
        }
      };

      const fetchCreateSection = async () => {
        if (allSections[props.group] && allSections[props.group][props.type]) {
          let guid = allSections[props.group][props.type][0].id;
          let sec = await getSection(guid);
          let sectionObj = ng.sections.Section.fromObject(sec.payload);
          if (sectionObj && sectionObj.id) {
            sectionObj.id.guid = uuid(); // Assign a new GUID for the new section
            sectionObj.id.name = `new${props.type}Section`; // Clear the name for the new section
            setSection(sectionObj.deepClone());
          }
        }
      };

      if (props.modelState === "edit") {
        fetchEditSection();
      } else {
        fetchCreateSection();
      }
    }
  }, [props.isCreationModalOpen]);

  return (
    <SXModalBase
      header={t("custom_.label") + " " + props.type + "-" + t("section_.label")}
      show={props.isCreationModalOpen}
      size="lg"
      close={() => {
        dispatch(closeModal("SectionCreationModal"));
      }}
      body={
        <>
          {section && (
            <NGCustomSection
              workingSec={section}
              type={props.type}
              setSec={(sec) => {
                setSection(sec.deepClone());
              }}
            />
          )}
        </>
      }
      footer={
        <>
          <Button
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("SectionCreationModal"));
            }}
          >
            {t("general.cancel")}
          </Button>
          <Button
            id="create-edit-section-btn"
            className="modal-btn"
            onClick={async () => {
              try {
                let secjson = ng.sections.Section.toObject(section!) || null;
                if (secjson) secjson!.id!.guid = uuid();

                if (props.modelState === "edit") {
                  secjson!.id!.guid = props.SectionGuid; // Preserve the original GUID for edits
                  if (secjson) await editSection(secjson);

                  if (props.currentSelectedSectionGuid == props.SectionGuid) {
                    await setProjectSectionGuid(props.SectionGuid, true); // Force update the section in the project
                  }
                } else if (secjson) {
                  let a = allSections[props.group][props.type].find((sec: any) => sec.name === secjson.id?.name);
                  if (a) {
                    AlertMessage("error_", t("error_.label"), "", t("MSG_section_name_is_taken_.label"));
                    return;
                  }
                  await createSection(secjson, props.type, props.group);
                }
                dispatch(closeModal("SectionCreationModal"));
              } catch (error) {
                report_exception(t, error, t("section_.label"));
              }
            }}
          >
            {props.modelState === "create" ? t("create_.label") : t("edit_.label")}
          </Button>
        </>
      }
    />
  );
};
